module.exports = __webpack_public_path__ + "img/waistband length.368cd551.png";